import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { fmtEUR, fmtDate } from "../../lib/format";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { toast } from "sonner";

export default function CollegaDialog({ contratto, onClose }) {
  const [lista, setLista] = useState([]);
  const [prec, setPrec] = useState("");
  const [nota, setNota] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (contratto) api.get(`/investments/${contratto.id}/collegabili`).then((r) => setLista(r.data)).catch(() => setLista([])); }, [contratto]);
  const go = async () => {
    if (!prec) return toast.error("Scegli il contratto precedente");
    setBusy(true);
    try { const r = await api.post(`/investments/${contratto.id}/collega-precedente`, { precedente_id: prec, nota }); toast.success(`Collegato: ${r.data.precedente} → ${r.data.successivo}`); onClose(true); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!contratto) return null;
  return (
    <Dialog open onOpenChange={() => onClose(false)}>
      <DialogContent data-testid="collega-dialog">
        <DialogHeader><DialogTitle>Collega {contratto.codice} al contratto da cui deriva</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Solo riferimento storico: nessun importo, stato o documento viene modificato (i contratti sono già registrati). Serve per mostrare la catena nel rendiconto e nel portale.</p>
        <Label className="text-xs">Contratto precedente</Label>
        <Select value={prec} onValueChange={setPrec}><SelectTrigger data-testid="collega-prec"><SelectValue placeholder="Scegli…" /></SelectTrigger>
          <SelectContent>{lista.map((c) => <SelectItem key={c.id} value={c.id}>{c.codice} · {c.operazione} · {fmtEUR(c.capitale)}{c.utili ? ` + utili ${fmtEUR(c.utili)}` : ""} · {fmtDate(c.sottoscrizione)}</SelectItem>)}</SelectContent></Select>
        {lista.length === 0 && <div className="text-xs text-muted-foreground">Nessun altro contratto collegabile per questo associato.</div>}
        <Label className="text-xs">Nota (facoltativa)</Label><Input value={nota} onChange={(e) => setNota(e.target.value)} placeholder="es. capitale + utili reinvestiti con bonifico unico" data-testid="collega-nota" />
        <DialogFooter><Button variant="outline" onClick={() => onClose(false)}>Annulla</Button><Button onClick={go} disabled={busy || !prec} data-testid="collega-confirm">Collega</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
